'use strict';

const $ = require('jquery');

class Header {

    constructor() {

        this.scrollIndicator();
        this.toggleDropdownMenu();

    }

    scrollIndicator() {
        let $scrollIndicator = $('.js-scroll-indicator');
        if ($scrollIndicator.length > 0) {
            App.Globals.$window.on('scroll load', () => {
                let winScroll = document.body.scrollTop || document.documentElement.scrollTop;
                let height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
                let scrolled = (winScroll / height) * 100;
                $scrollIndicator.width(scrolled + '%');
            });
        }
    }

    toggleDropdownMenu() {
        const $clickHandler = $('.js-toggle-dropdown');

        $clickHandler.on('click', (element) => {
            $(element.currentTarget)
                .toggleClass('active')
                .closest('.menu-item')
                .find('.dropdown-menu')
                .toggleClass('open');
        });
    }

}

module.exports = Header;
